import React, { useState } from "react";

import "./Footer.css";
import { notification } from "antd";
import { Link } from "react-router-dom";
import roundLine from "../Img/round line.png";
import {
  PhoneOutlined,
  MailOutlined,
  FacebookOutlined,
  LinkedinOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import Img1 from "../Img/Header Icon.png";

import { db } from "../FirebaseAdd";
import { collection, addDoc } from "firebase/firestore";

export default function Footer() {
  const [email, setEmail] = useState("");

  const usersCollectionRef = collection(db, "subscribe");

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const handleSubscribe = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email.trim() === "") {
      openNotificationWithIcon(
        "warning",
        "Warning",
        "Please provide an email address."
      );
    } else if (!emailPattern.test(email)) {
      openNotificationWithIcon(
        "warning",
        "Warning",
        "Please provide a valid email address."
      );
    } else {
      try {
        await addDoc(usersCollectionRef, { email });
        openNotificationWithIcon(
          "success",
          "Success",
          "You have successfully subscribed!"
        );
        setEmail(""); // Clear the input field after successful subscription
      } catch (error) {
        console.error("Error adding document: ", error);
        openNotificationWithIcon(
          "error",
          "Error",
          "Failed to subscribe. Please try again later."
        );
      }
    }
  };

  return (
    <div className="Footer-Body">
      <div className="Footer-Top-Box">
        <img src={roundLine} alt="" className="Footer-Top-Img1" />
        <div className="Footer-Top-Div">
          <p className="Footer-Text1">|| Get Latest Updates</p>
        </div>
        <img src={roundLine} alt="" className="Footer-Top-Img2" />
      </div>
      <p className="Footer-Text2">Subscribe For Newsletter</p>
      <div className="Footer-Mid-div1">
        <input
          className="Footer-Mid-Input"
          placeholder="demo@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className="Footer-Mid-Button" onClick={handleSubscribe}>
          Subscribe Now
        </button>
      </div>
      <div className="Footer-Mid-div2">
        <a href="tel:01580-233165" className="Footer-Mid-Button2">
          <div className="Footer-Mid-div3">
            <PhoneOutlined />
          </div>
          <p className="Footer-Text3">01580-233165</p>
        </a>

        <a
          href="mailto:tasnimshahriarakash@gmail.com"
          className="Footer-Mid-Button2"
        >
          <div className="Footer-Mid-div3">
            <MailOutlined />
          </div>
          <p className="Footer-Text3">tasnimshahriarakash@gmail.com</p>
        </a>

        <div className="Footer-Mid-div4">
          <a
            className="Footer-Mid-aTag"
            href="https://www.facebook.com/tasnimSakash/"
            target="blank"
          >
            <FacebookOutlined />
          </a>

          <a
            className="Footer-Mid-aTag"
            href="https://www.linkedin.com/in/tasnimsakash/"
            target="blank"
          >
            <LinkedinOutlined />
          </a>

          <a
            className="Footer-Mid-aTag"
            href="https://my-portfolio-d43ec.web.app/"
            target="blank"
          >
            <GlobalOutlined />
          </a>
        </div>
      </div>
      <div className="Footer-Bottom-Box">
        <p className="Footer-Box-text5">
          Copyright &copy; {new Date().getFullYear()} Made with 🤍 by
          <a
            className="Footer-Bottom-aTag"
            href="https://my-portfolio-d43ec.web.app/"
            target="blank"
          >
            tasnimSakash
          </a>
        </p>
        <Link to="/" className="Footer-Bottom-Link">
          <img className="Footer-Bottom-Icon" src={Img1} alt="Img" />
        </Link>
      </div>
    </div>
  );
}
